import { createContext } from "react";

export enum CountryType {
  Belgium = "Belgium",
  US = "US",
  Netherlands = "The Netherlands",
  France = "France",
  Germany = "Germany",
  Other = "Other",
}

export enum CompanyType {
  BV = "BV",
  NV = "NV",
  UnderIncorporation = "Under Incorporation",
  INC = "Inc.",
  LLC = "LLC",
  Limited = "Limited",
  SARL = "SARL",
  SA = "SA",
  GmbH = "GmbH",
}

export enum TimeType {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Quarter = "Quarter",
  Year = "Year",
}

export enum VestingFrequency {
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  SixMonths = "Six Months",
  Yearly = "Yearly",
}

export enum CallOption {
  Euro = "1 euro",
  FairMarket = "Fair market value",
  FairMarketDiscount = "Discounted fair market value",
  InitialSubscription = "Initial subscription price",
  CustomPrice = "Custom price",
}

export enum SharesType {
  Percentage = "Percentage",
  Shares = "Shares",
}

export enum FoundersType {
  NaturalPerson = "Natural Person",
  Company = "Company",
}

export type Company = {
  name: string;
  country: CountryType;
  type: CompanyType | string;
};

export type ShareholdersType =
  | {
      type: SharesType;
      shares: { share: string }[];
      externalShareholders: { external: false };
    }
  | {
      type: SharesType;
      shares: { share: string }[];
      externalShareholders: { external: true; share: string };
    };
export type CallOptions =
  | { callOptions: false }
  | {
      callOptions: true;
      allShares: boolean;
      percentageOfShares: string;
      shareValue: CallOption;
      shareValueDiscount: string;
      shareValuePrice: string;
    };

export type CliffPeriod =
  | { cliffOptions: false }
  | {
      cliffOptions: true;
      cliffShares: string;
    };

export type vestedShares = {
  vestedOptions: string;
  vestedShares: string;
}[];

export type ResultType =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | CliffPeriod
  | vestedShares
  | Company
  | (number | undefined)[]
  | { name: string; type: FoundersType }
  | { name: string; type: FoundersType }[]
  | { firstName: string; lastName: string }[]
  | { timeHours: string; timeWeeks: string }
  | { timeHours: string; timeWeeks: string }[]
  | { time: string; type: TimeType }[]
  | { time: string; type: TimeType }
  | { time: number; type: TimeType }[]
  | { time: number; type: TimeType }
  | string[][]
  | { tags: string[]; extra: string }
  | { tags: string[]; extra: string }[]
  | ShareholdersType
  | {
      vested: CallOptions;
      unvested: CallOptions;
      vestedBad: CallOptions;
    }
  | {
      frequency: VestingFrequency;
      type: string;
    };

export const ResultContext = createContext<{
  setResult: (result: Record<number, ResultType>) => void;
  result: Record<number, ResultType>;
}>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setResult: () => {},
  result: {},
});
